'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_SiteTables$$anon$17() {
}
export { $c_Lpresto_SiteTables$$anon$17 as $c_Lpresto_SiteTables$$anon$17 };
$p = $c_Lpresto_SiteTables$$anon$17.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_SiteTables$$anon$17;
/** @constructor */
function $h_Lpresto_SiteTables$$anon$17() {
}
export { $h_Lpresto_SiteTables$$anon$17 as $h_Lpresto_SiteTables$$anon$17 };
$h_Lpresto_SiteTables$$anon$17.prototype = $p;
$p.b6 = (function(_$40) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(_$40, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((_$41) => _$41.ot)), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_math_Ordering$Boolean$());
});
var $d_Lpresto_SiteTables$$anon$17 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_SiteTables$$anon$17, "presto.SiteTables$$anon$17", ({
  Rv: 1,
  G: 1
}));
export { $d_Lpresto_SiteTables$$anon$17 as $d_Lpresto_SiteTables$$anon$17 };
//# sourceMappingURL=presto.-Site-Tables$$anon$17.js.map
